import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function IdsCheckBoxChecked(props: SvgIconProps) {
  return(
    <SvgIcon {...props}>
      <path id="footprint" d="M0,0H24V24H0V0Z" fill="none"/>
      <rect id="base" x="2" y="2" width="20" height="20" rx="2" ry="2" fill="#2c6baa"/>
      <path id="check" d="M17.87,6.78c.43-.44,1.13-.45,1.57-.02,.41,.4,.44,1.03,.11,1.47l-.09,.11-8.69,8.89c-.4,.4-1.02,.44-1.46,.11l-.11-.09-4.64-4.52c-.44-.43-.45-1.13-.02-1.57,.4-.41,1.03-.44,1.47-.11l.11,.09,3.85,3.75,7.92-8.1Z" fill="#fff"/>
    </SvgIcon>
  );
}